import appStore from "../../../stores/AppStore";
import { WorkflowState, WorkflowContext } from "../types/workflow.types";

export class WorkflowEngine {
  async executeStep(
    state: WorkflowState,
    context: WorkflowContext
  ): Promise<void> {
    switch (state) {
      case WorkflowState.SYNKPASS:
        await this.executeSynkPassStep(context);
        break;
      case WorkflowState.SYNKCRYPT:
        await this.executeSynkCryptStep(context);
        break;
      case WorkflowState.SYNKSMAH:
        await this.executeSynkSmashStep(context);
        break;
      case WorkflowState.SYNKSWAP:
        await this.executeSynkSwapStep(context);
        break;
      default:
        break;
    }
  }

  private async executeSynkPassStep(context: WorkflowContext): Promise<void> {
    try {
      // Open SynkPass with appropriate URL
      const targetId = context.targetId || "james.files";
      const username = context.username || "kardon";
      const customUrl = `https://synkpass.synk.ws/?url=${targetId}&username=${username}`;

      console.log("🔑 Nova - Opening SynkPass:");
      console.log("  - targetId:", targetId);
      console.log("  - username:", username);
      console.log("  - customUrl:", customUrl);

      // Use focusOrLaunchApp to either focus existing instance or launch new one
      appStore.focusOrLaunchApp("SynkPass", {
        customUrl: customUrl,
      });
    } catch (error) {
      console.error("Error opening SynkPass:", error);
    }
  }

  private async executeSynkCryptStep(context: WorkflowContext): Promise<void> {
    try {
      // Open SynkCrypt with integration URL
      let props: any = {};

      if (context.integrationUrl) {
        props = { integrationUrl: context.integrationUrl };
      } else {
        props = { customUrl: "https://synkcrypt.synk.ws" };
      }

      console.log("🔐 Nova - Opening SynkCrypt:");
      console.log("  - Props passed:", props);

      // Use focusOrLaunchApp to either focus existing instance or launch new one
      appStore.focusOrLaunchApp("SynkCrypt", props);
    } catch (error) {
      console.error("Error opening SynkCrypt:", error);
    }
  }

  private async executeSynkSmashStep(context: WorkflowContext): Promise<void> {
    try {
      // Open SynkSmash for P2P sending
      let props: any = {};

      if (context.integrationUrl) {
        props = { integrationUrl: context.integrationUrl };
      } else {
        props = { customUrl: "https://smash.synk.ws" };
      }

      console.log("📤 Nova - Opening SynkSmash:");
      console.log("  - Props passed:", props);
      console.log("  - Context:", context);

      // Use focusOrLaunchApp to either focus existing instance or launch new one
      appStore.focusOrLaunchApp("SynkSmash", props);
    } catch (error) {
      console.error("Error opening SynkSmash:", error);
    }
  }

  private async executeSynkSwapStep(context: WorkflowContext): Promise<void> {
    try {
      // Open SynkSwap for crypto bonus with specific parameters
      const customUrl = "https://swap.synk.ws/?mode=erc20&fromAmount=0.05";
      const props = { customUrl };

      console.log("💱 Nova - Opening SynkSwap:");
      console.log("  - Props passed:", props);
      console.log("  - URL:", customUrl);

      // Use focusOrLaunchApp to either focus existing instance or launch new one
      appStore.focusOrLaunchApp("SynkSwap", props);
    } catch (error) {
      console.error("Error opening SynkSwap:", error);
    }
  }

  async continueWorkflow(context: WorkflowContext): Promise<void> {
    // Logic to move to next step
    const nextStep = this.getNextStep(context.step);
    if (nextStep) {
      context.step = nextStep;
      await this.executeStep(this.getStateFromStep(nextStep), context);
    }
  }

  private getNextStep(currentStep: number): number | null {
    const steps = [0, 1, 2, 3, 4, 5]; // SYNKPASS, SYNKCRYPT, SYNKSMAH, SYNKSWAP, COMPLETED
    const currentIndex = steps.indexOf(currentStep);
    return currentIndex < steps.length - 1 ? steps[currentIndex + 1] : null;
  }

  private getStateFromStep(step: number): WorkflowState {
    switch (step) {
      case 0:
        return WorkflowState.IDLE;
      case 1:
        return WorkflowState.SYNKPASS;
      case 2:
        return WorkflowState.SYNKCRYPT;
      case 3:
        return WorkflowState.SYNKSMAH;
      case 4:
        return WorkflowState.SYNKSWAP;
      case 5:
        return WorkflowState.COMPLETED;
      default:
        return WorkflowState.IDLE;
    }
  }
}
